import { BsHandThumbsUp } from "react-icons/bs";
import React from 'react';
import { useTranslation } from '../hx/useTranslation';
import * as FxFetch from '../fx/FxFetch';
import * as FxLog from '../fx/FxLog';
import CxDlgAlert from '../cx/CxDlgAlert';
import { getStoreValue } from "./GxStore";

const GxEmail = (props) => {
  const [{ trans }] = useTranslation();

  const r_dlg_alert = React.useRef(null);

  // Exponemos la función hacia el componente padre
  React.useImperativeHandle(props.xref, () => {
    return {
      sendSlsDoc,
    };
  });

  const doSendPdfEmailDirectly = async (strEndpointPdf, obFilterPdf, strEmailAddress, strSubject, strContent) => {
    try {
      // Mostramos cartel de espera
      r_dlg_alert.current.setText(trans('msg.sending_x', 'field.email'));
      r_dlg_alert.current.setProgressMsg(trans('msg.please_wait'));
      r_dlg_alert.current.setIcon(null);
      r_dlg_alert.current.setTextColor('var(--ibs_color_blue)');
      r_dlg_alert.current.setHasButtonClose(false);
      r_dlg_alert.current.setOpen(true);

      // 1. Pide a Spring Boot que genere el PDF
      const arrPdfResponse = await FxFetch.doJsonF(strEndpointPdf, obFilterPdf, {});
      
      // 2. Extrae el texto Base64
      let strBase64Raw = null;
      if (Array.isArray(arrPdfResponse) && arrPdfResponse.length > 0 && arrPdfResponse[0]) {
        strBase64Raw = arrPdfResponse[0].obPDF;
      } else if (arrPdfResponse && !Array.isArray(arrPdfResponse) && arrPdfResponse.obPDF) {
        strBase64Raw = arrPdfResponse.obPDF;
      }

      if (!strBase64Raw) {
        let strErr = trans('msg.operation_failed') + ': PDF_GENERATION_FAILED';
        FxLog.errorx('GxEmail.doSendPdfEmailDirectly', 'No se pudo generar o extraer el PDF en memoria.', arrPdfResponse);
        r_dlg_alert.current.setText(strErr);
        r_dlg_alert.current.setProgressMsg('');
        r_dlg_alert.current.setIcon(null);
        r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
        r_dlg_alert.current.setHasButtonClose(true);
        r_dlg_alert.current.setOpen(true);
        return { boSuccess: false, strError: strErr };
      }
      
      const strBase64Clean = strBase64Raw.replace('data:application/pdf;base64,', '');

      // 3. Prepara los filtros y el registro para el envío
      const filter = {
        ...obFilterPdf,
        addressee_txName: '',
        addressee_txEmail: strEmailAddress,
        addressee_txMobile: '',
        addressee_txCity: '',
        addressee_txState: '',
        addressee_txCountry: '',
        txEmailSubject: strSubject,
        txEmailContent: strContent
      };

      const record = {
        base64: strBase64Clean
      };

      // 4. Ejecuta el envío
      const arrSendResponse = await FxFetch.doJsonF('dlg_send/send/email', filter, record);

      let strStatus = null;
      let strValue = null;

      if (Array.isArray(arrSendResponse) && arrSendResponse.length > 0 && arrSendResponse[0]) {
        strStatus = arrSendResponse[0].theStatus;
        strValue = arrSendResponse[0].theValue;
      } else if (arrSendResponse && !Array.isArray(arrSendResponse)) {
        strStatus = arrSendResponse.theStatus;
        strValue = arrSendResponse.theValue;
      }

      // 5. Evaluación del resultado y despliegue del aviso
      r_dlg_alert.current.setOpen(false);
      if (strStatus === 'OK') {
        //r_dlg_alert.current.setOpen(false);
        r_dlg_alert.current.setText(trans('msg.x_sent_1', 'field.email'));
        r_dlg_alert.current.setProgressMsg('');
        r_dlg_alert.current.setIcon(<BsHandThumbsUp fontSize="30px" style={{ fill: 'var(--ibs_color_green)', paddingBottom: '10px' }} />);
        r_dlg_alert.current.setTextColor('var(--ibs_color_green)');
        r_dlg_alert.current.setAutoCloseMilliseconds(1500);
        r_dlg_alert.current.setAutoClose(true);
        r_dlg_alert.current.setOpen(true);
        return { boSuccess: true, strError: null };
      } else {
        let strErr = '';
        switch (strValue) {
          case 'rv_missing_branch_email':
            strErr = `${trans('msg.x_not_configured_1', 'field.email')}`;
            break;
          case 'rv_debugging':
            strErr = `${trans('msg.operation_failed')}: DEBUGGING`;
            break;
          default:
            strErr = `${trans('msg.operation_failed')}: ${strValue || 'UNKNOWN_ERROR'}`;
            break;
        }
        r_dlg_alert.current.setText(strErr);
        r_dlg_alert.current.setProgressMsg('');
        r_dlg_alert.current.setIcon(null);
        r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
        r_dlg_alert.current.setHasButtonClose(true);
        r_dlg_alert.current.setOpen(true);
        return { boSuccess: false, strError: strErr };
      }

    } catch (obError) {
      FxLog.errorx('GxEmail.doSendPdfEmailDirectly', obError);
      let strErr = obError.message || 'EXCEPTION_ERROR';
      r_dlg_alert.current.setText(strErr);
      r_dlg_alert.current.setProgressMsg('');
      r_dlg_alert.current.setIcon(null);
      r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
      r_dlg_alert.current.setHasButtonClose(true);
      r_dlg_alert.current.setOpen(true);
      return { boSuccess: false, strError: strErr };
    }
  };

  /**
   * Envía un Documento de Venta por correo directamente.
   * Las validaciones previas también usan el snackbar de error.
   */
  const sendSlsDoc = async (row, listType) => {
    if (!row) {
      r_dlg_alert.current.setText('NO_ROW_DATA');
      r_dlg_alert.current.setProgressMsg('');
      r_dlg_alert.current.setIcon(null);
      r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
      r_dlg_alert.current.setHasButtonClose(true);
      r_dlg_alert.current.setOpen(true);
      return false;
    }
    
    if (!row.txEmail) {
      r_dlg_alert.current.setText(trans('msg.missing_x_in_x_file', 'field.email', 'field.client'));
      r_dlg_alert.current.setProgressMsg('');
      r_dlg_alert.current.setIcon(null);
      r_dlg_alert.current.setTextColor('var(--ibs_color_red)');
      r_dlg_alert.current.setHasButtonClose(true);
      r_dlg_alert.current.setOpen(true);
      return false;
    }

    const strEndpointPdf = 'slsDoc/report';
    
    let inXXX = null;
    let docTypeName = null;
    switch (listType) {
      case 'q': 
        inXXX = row.inQuotation; 
        docTypeName = trans('field.quotation'); 
        break;
        
        case 'i': 
        inXXX = row.inInvoice; 
        docTypeName = trans('field.invoice'); 
        break;
        
        case 'r': 
        inXXX = row.inReceipt; 
        docTypeName = trans('field.receipt'); 
        break;

      default: break;
    }

    const obFilterPdf = { 
      reportFormat: 'PDF',
      inXXX: inXXX,
      inClient: row.inClient,
      docType: listType,
      docSize: 'A4', 
      nuCopies: '0',
      salesSlipWidth: '60',
      salesSlipMarginLeft: '0'
    };

    let cy = getStoreValue('StoreSession', 'txCompany');
    let strSubject = `${docTypeName} - ${cy}`;
    let strContent = trans('msg.email_with_attachment_x_x', docTypeName, cy);

    // Llamada silenciosa interna (ya despliega los snacks de éxito/error por sí misma)
    const obResult = await doSendPdfEmailDirectly(
      strEndpointPdf,
      obFilterPdf,
      row.txEmail,
      strSubject,
      strContent
    );

    return obResult.boSuccess;
  };

  return (
    <div>
      <CxDlgAlert xref={r_dlg_alert} />
    </div>
  );
};

export default GxEmail;